import React from 'react';
import PropTypes from 'prop-types';

const CurrencyDisplay = ({ amount }) => {
  return (
    <>{`${amount?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })}`}</>
  );
};

CurrencyDisplay.defaultProps = {
  amount: 0,
};

CurrencyDisplay.propTypes = {
  amount: PropTypes.number.isRequired,
};

export default CurrencyDisplay;
